import React from 'react';
import classnames from 'classnames';
import {useCompleteInspectionContext} from '../../CompleteInspectionContext';
import styles from './styles.module.scss';
import {getBreakLinesTextShumaType3} from "../../../utils/texts";

const Section6Text78e = React.forwardRef(({}, ref) => {
  const context = useCompleteInspectionContext();
  const {
    houseAreaAccordingHeskemShituf,
  } = context.data.pdfData;

    return (
      <div ref={ref}>
        {Boolean(houseAreaAccordingHeskemShituf) && (
          <div className={classnames(styles.itemText, styles.innerPadding)}>
            <span className={styles.bold}>שטח בהתאם לתשריט הסכם שיתוף: </span>
            <span>{getBreakLinesTextShumaType3(houseAreaAccordingHeskemShituf)}</span>
          </div>
        )}
      </div>
    )
});

export default Section6Text78e;
